import React, { memo, forwardRef } from "react";
const SvgEmptyset = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M9.768 24.507a1 1 0 101.732 1l1.2-2.077a6.29 6.29 0 003.3.943c3.866 0 7-3.581 7-8 0-2.525-1.023-4.776-2.622-6.242L21.5 8.187a1 1 0 10-1.732-1L18.72 9A6.234 6.234 0 0016 8.373c-3.866 0-7 3.582-7 8 0 2.261.82 4.303 2.14 5.758l-1.372 2.376zm3.936-2.818c.71.443 1.502.684 2.296.684 2.519 0 5-2.427 5-6 0-1.85-.665-3.393-1.657-4.45l-5.639 9.766zm4.008-10.942l-5.504 9.534C11.47 19.266 11 17.928 11 16.373c0-3.573 2.481-6 5-6 .583 0 1.164.13 1.712.374z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgEmptyset.displayName = "SvgEmptyset";
const MemoForwardRef = memo(SvgEmptyset);
export default MemoForwardRef;
